import type { State } from '../../types';
import type { ContractViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function contractsNotDeleted(state: State): ContractViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.contractsById).filter((e) => !e.deleted);
}
